
const defaultState = {
  trainingRequirement: {},
  updateResult: false,
  requestType: ''
}

export default (state = defaultState, action) => {
  var newState = {...state}

  switch (action.type){
    case 'CREATE_TRAINING_REQUIREMENT_REQUEST':
      newState.requestType = action.type;
      return newState;
    case 'CREATE_TRAINING_REQUIREMENT_SUCCESS':
      newState.requestType = action.type;
      newState.trainingRequirement = action.body;
      return newState;
    case 'CREATE_TRAINING_REQUIREMENT_FAILURE':
      newState = defaultState;
      return newState;
    case 'UPDATE_TRAINING_REQUIREMENT_REQUEST':
      newState.requestType = action.type;
      newState.updateResult = false;
      return newState;
    case 'UPDATE_TRAINING_REQUIREMENT_SUCCESS':
      newState.requestType = action.type;
      newState.updateResult = action.body;
      newState.trainingRequirement = action.body;
      return newState;
    case 'UPDATE_TRAINING_REQUIREMENT_FAILURE':
      newState = defaultState;
      return newState;
    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/training_requirements.js